export enum PlayState {
  play = 'play',
  reverse = 'reverse',
  stop = 'stop',
  pause = 'pause',
}
